import React from 'react';
import { offertypeFormatter } from '@components/dashboard/my-overview-page/MyOrders/MyOrders.formatters';
import { OrderCreationType } from 'next-common';

interface OfferTypeBadgeProps {
  type: string;
}
const OfferTypeBadge = ({ type }: OfferTypeBadgeProps) => {
  const label = offertypeFormatter(type);
  if (
    ![OrderCreationType.CUSTOMER, OrderCreationType.STOCK, OrderCreationType.DEMO].includes(type as OrderCreationType)
  ) {
    return null;
  }

  return (
    <span className="flex px-3 justify-center items-center text-sm/[170%] font-semibold rounded-full outline text-paleGrey outline-paleGrey">
      {label}
    </span>
  );
};

export default OfferTypeBadge;
